import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosError, AxiosResponse } from 'axios';
import { setScheduledBatch } from 'ducks/scheduled-batch/slices';
import { Slices } from 'ducks/slices';
import { BatchDefinitionsItemAPI } from 'ducks/types/api-types';
import { Andromeda } from 'utils/axios';
import { handleError } from 'utils/errors';

export const getBatchDefinition = createAsyncThunk<BatchDefinitionsItemAPI, number>(
  `${Slices.BATCH_DEFINITION}/get`,
  async (entity_id, { rejectWithValue, dispatch }) => {
    try {
      const res: AxiosResponse['data'] = await Andromeda.get(`/batch_definitions/${entity_id}`);
      dispatch(setScheduledBatch(res.data));
      return res.data;
    } catch (error) {
      handleError(error);
      return rejectWithValue(error as AxiosError);
    }
  },
);
